// Mirrors PAYROLL_RUN_STATUS_* in api/core/payroll_runs.go.
enum PayrollRunStatus {
  Draft = 10,
  Submitting = 30,
  Submitted = 40,
  SyncingData = 50,
  Completed = 90,
  Failed = 95,
}

export default PayrollRunStatus;

export const PayrollRunStatusLabels: { [key: number]: string } = {
  [PayrollRunStatus.Draft]: 'Draft',
  [PayrollRunStatus.Submitting]: 'Submitting',
  [PayrollRunStatus.Submitted]: 'Submitted',
  [PayrollRunStatus.SyncingData]: 'Syncing data',
  [PayrollRunStatus.Completed]: 'Completed',
  [PayrollRunStatus.Failed]: 'Failed',
};

// Chip colour per status — used by the list page Status column and the
// details page heading. Picked to match the rest of the app's status chips.
export const PayrollRunStatusColors: { [key: number]: string } = {
  [PayrollRunStatus.Draft]: 'grey',
  [PayrollRunStatus.Submitting]: 'blue',
  [PayrollRunStatus.Submitted]: 'amber darken-2',
  [PayrollRunStatus.SyncingData]: 'cyan darken-1',
  [PayrollRunStatus.Completed]: 'green',
  [PayrollRunStatus.Failed]: 'red',
};
